import { ServiceManager, ServiceType } from "../ServiceManager";
import { IRUMRecorder } from "./IRUMRecorder";

class RUMAPICall {
    URL: string;
    Method: string;
    Started: number = performance.now();
    Completed: number = 0;
    Status: number = 0;
    Errored: boolean = false;
    Referrer: string = window.location.href;

    constructor(url: string, method: string) {
        this.URL = url;
        this.Method = method;
    }

    SetComplete(statusCode: number) {
      this.Status = statusCode;
      this.Completed = performance.now();
      
      ServiceManager.GetAll<IRUMRecorder>(ServiceType.RUMRecorder).forEach((r) => {
        r.RecordAPI(this);
      });
    }
    
    SetErrored(statusCode: number) {
      this.Status = statusCode;
      this.Completed = performance.now();
      this.Errored = true;

      ServiceManager.GetAll<IRUMRecorder>(ServiceType.RUMRecorder).forEach((r) => {
        r.ReportAPIError(this);
      });
    }
}

export { RUMAPICall }
